@layer ch-tabular-grid {
  ch-tabular-grid-columnset {
    display: contents;
  }
}
@layer ch-tabular-grid {
  ch-tabular-grid-row {
    display: contents;
  }
  ch-tabular-grid-row[collapsed] > ch-tabular-grid-rowset {
    display: none;
  }
  ch-tabular-grid-row:is([leaf=false], :has(> ch-tabular-grid-rowset)) > ch-tabular-grid-cell::part(caret) {
    visibility: visible;
  }
  ch-tabular-grid-row[dragging] {
    display: flex;
    position: fixed;
    pointer-events: none;
    box-shadow: rgba(0, 0, 0, 0.7) 0px 5px 15px;
    z-index: 1000;
    transition: top var(--row-drag-transition-duration, 0.1s);
  }
}
@layer ch-tabular-grid {
  ch-tabular-grid-rowset {
    display: contents;
  }
  ch-tabular-grid-rowset[collapsed] > :not(ch-tabular-grid-rowset-legend) {
    display: none;
  }
}
@layer ch-tabular-grid {
  ch-tabular-grid-cell {
    position: sticky;
    grid-column: var(--grid-column);
    transition: transform var(--column-drag-transition-duration, 0.2s);
  }
  ch-tabular-grid-cell[selected] {
    --ch-tabular-grid-cell-z-index-active: var(
      --ch-tabular-grid-cell-active-layer
    );
  }
  ch-tabular-grid-cell,
  ch-tabular-grid-row[selected] > ch-tabular-grid-cell,
  ch-tabular-grid-row[highlighted] > ch-tabular-grid-cell {
    background-color: inherit;
    margin-block-start: inherit;
    margin-block-end: inherit;
    border-block-start: inherit;
    border-block-end: inherit;
    padding-block-start: inherit;
    padding-block-end: inherit;
  }
  ch-tabular-grid-cell:before {
    margin-inline-start: calc(var(--indent) * var(--level));
  }
  ch-tabular-grid-cell::part(indent) {
    width: calc(var(--indent) * var(--level));
  }
  ch-tabular-grid-cell::part(caret) {
    visibility: hidden;
  }
}